/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { AviPermissionResource } from 'generated-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

import { LicensePoolItem } from 'ng/modules/items/factories/license-pool.item.factory';

export type TLicensePoolCollection = typeof LicensePoolCollection;

/**
 * @description License Pool Collection Factory
 * @author Deepak Chaudhary
 */
export class LicensePoolCollection extends Collection {
    public static readonly ngDependencies = [LicensePoolItem];

    constructor(args = {}) {
        const extendedArguments = {
            objectName: 'albservices/pool',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_SYSTEMCONFIGURATION,
            ...args,
        };

        super(extendedArguments);
        this.itemClass_ = this.getNgDependency(LicensePoolItem);
    }
}
